export const getAppointmentStatusColor = (status) => {
  switch (status) {
    case 'Completed':
      return { bgColor: '#7BB661', textColor: '#ffffff' };
    case 'InProgress':
      return { bgColor: '#0984FC', textColor: '#ffffff' };
    case 'New':
      return { bgColor: '#FF5348', textColor: '#ffffff' };
    case 'Unavailable':
      return { bgColor: '#FEF65C', textColor: '#000000' };
    case 'partial_completed':
      return { bgColor: '#C4DE6F', textColor: '#ffffff' };
    default:
      return { bgColor: '#00B9FC', textColor: '#ffffff' };
  }
};

//#7BB661, #C4DE6F, #FF5348, #FEF65C, #00B9FC and #0984FC
